module.exports = __webpack_public_path__ + "img/clubsaway-logo-desktop.5c97fe30.svg";